import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { programsAPI } from 'api';
import { RejectWithMessage } from 'features/types';
import { ProgramDataForContext, SelectedContextState, SelectedProgramContextTab } from './types';
import { getErrorMessage } from 'utils/error';
import { RootState } from 'app/root-reducer';

export const getProgramDataForContext = createAsyncThunk<ProgramDataForContext, string, RejectWithMessage>(
  'selected-context/get-program-data-for-context',
  async (id, { rejectWithValue }) => {
    try {
      return await programsAPI.getProgramDataForContext(id);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

const initialState: SelectedContextState = {
  status: 'idle',
  programContext: {
    selectedId: undefined,
    tab: SelectedProgramContextTab.GroupHub,
    data: {
      programDataIsLoading: false,
      programData: null,
    },
  },
  error: null,
};

const selectedContextSlice = createSlice({
  name: "selected-program-context",
  initialState,
  reducers: {
    setSelectedProgramContextSelectedId(state, action: PayloadAction<string>) {
      state.programContext.selectedId = action.payload;
    },
    setSelectedProgramContext(state, action: PayloadAction<ProgramDataForContext>) {
      state.programContext.data.programData = action.payload;
    },
    clearSelectedProgramContext(state) {
      state.programContext.data.programData = null;
    },
    setSelectedProgramContextTab(state, action: PayloadAction<SelectedProgramContextTab>) {
      state.programContext.tab = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getProgramDataForContext.pending, (state) => {
      state.status = 'pending';
      state.programContext.data.programDataIsLoading = true;
    });
    builder.addCase(getProgramDataForContext.fulfilled, (state, action: PayloadAction<ProgramDataForContext>) => {
      state.status = 'fulfilled';
      state.programContext.data.programDataIsLoading = false;
      state.programContext.data.programData = action.payload;
      state.error = null;
    });
    builder.addCase(getProgramDataForContext.rejected, (state) => {
      state.status = 'rejected';
      state.programContext.data.programDataIsLoading = false;
    });
  }
});

export const selectedProgramContext = (state: RootState) => state.selectedContext.programContext.data.programData;
export const selectedProgramContextSelectedId = (state: RootState) => state.selectedContext.programContext.selectedId;
export const selectedProgramContextSelectedTab = (state: RootState) => state.selectedContext.programContext.tab;

export const { setSelectedProgramContext, clearSelectedProgramContext, setSelectedProgramContextSelectedId, setSelectedProgramContextTab } = selectedContextSlice.actions;
export const selectedContextReducer = selectedContextSlice.reducer;